<template>
  <tg-layout prefixCls="my-team" :portalFooter="isMobile">
    <template slot="header">
      <portal to="tools" :disabled="!isMobile">
        <tg-search-tool :data="searchData" @on-submit="handleSearch">
          <el-input
            :placeholder="$t('component.form.input.placeholder.member')"
            v-model="searchData.targetName"
            class="tg-input input-search-username"
            clearable
            size="small"
          ></el-input>
        </tg-search-tool>
      </portal>
    </template>
    <template v-if="expandAll">
      <tg-tree
        :item="treeItem"
        :columns="columns"
        expandAll
        @on-toggle="handleTreeToggleNode"
        @on-info-click="handleShowItemInfo"
        @on-scroll="handleScroll"
      ></tg-tree>
    </template>
    <template v-else>
      <tg-tree
        :item="item"
        :columns="columns"
        @on-toggle="handleTreeToggleNode"
        @on-info-click="handleShowItemInfo"
        @on-scroll="handleScroll"
        v-loading="loading"
        :element-loading-text="loadingLabel"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      ></tg-tree>
    </template>
    <template slot="footer">
      <el-row
        type="flex"
        justify="space-between"
        align="middle"
        class="my-team-footer"
      >
        <el-row type="flex" justify="start" align="middle">
          <div
            v-html="
              $t('page.tg_business.my-team.footer.total_tg_business_num', {
                value: userInfo.total_tg_business_num || '-',
              })
            "
          ></div>
          <div
            v-html="
              $t('page.tg_business.my-team.footer.total_tg_num', {
                value: userInfo.total_tg_num || '-',
              })
            "
          ></div>
        </el-row>
        <!-- <el-button
          class="my-team--go-top"
          v-if="!expandAll"
          @click="handleToTopLevel"
        >{{ $t("page.tg_business.my-team.goTop") }}</el-button>-->
        <tg-button
          class="my-team--go-top"
          v-if="!expandAll"
          hoverBorderOnly
          theme="primary"
          border
          @click.native="handleToTopLevel"
          >{{ $t("page.tg_business.my-team.goTop") }}</tg-button
        >
      </el-row>
    </template>
    <el-alert
      type="tg-alert"
      show-icon
      v-show="alert.show"
      :style="alert.style"
      @close="alert.show = false"
      >{{ alert.username
      }}{{ $t("page.tg_business.my-team.noBelow") }}</el-alert
    >
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgTree from "@/components/tree/TgTree";
import apis from "@/apis";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgButton from "@/components/button/TgButton";

const api = apis.tg_business.myTeam;

export default {
  components: {
    TgLayout,
    TgTree,
    TgSearchTool,
    TgButton,
  },
  data() {
    return {
      expandAll: false,
      searchData: {
        targetName: "",
      },
      item: null,
      treeItem: null,
      fetchData: null,
      userInfo: {},
      loading: false,
      alert: {
        show: false,
        style: {},
        username: "",
      },
      pagination: {
        page: 1,
        per_page: 20,
        total_page: 1
      },
      columns: []
    };
  },
  computed: {
    loginUser() {
      return this.$user.username;
    },
    loadingLabel() {
      return this.$t("component.table.loading");
    },
    hasNextPage() {
      return this.pagination.page < this.pagination.total_page;
    }
  },
  created() {
    this.loading = true;
    api.getColumns().then(response => {
      this.columns = response.data;

      this.getBelowMember(this.loginUser, 1).then((data) => {
        this.treeItem = data;
        this.item = data;
        this.userInfo = data;
        this.loading = false;
      });
    });
  },
  methods: {
    getBelowMember(targetName, page) {
      this.loading = true;
      return new Promise((resolve) => {
        api
          .getBelowMember({ targetName, page })
          .then((response) => {
            if(response.retcode == 0){
              this.loading = false;
              this.pagination = response.pagination;
              return resolve(response.data);
            }
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },

    handleTreeToggleNode(event) {
      event.done = new Promise((resolve) => {
        // 要展開對象
        if (event.status) {
          // 目標尚未載入下線
          if (!event.item.isChecked) {
            this.getBelowMember(event.item.username, 1).then((data) => {
              if (!data.children || data.children.length == 0) {
                this.alert = {
                  show: true,
                  username: event.item.username,
                  style: {
                    position: "absolute",
                    width: "20%",
                    top: event.clickEvent.y + 20 + "px",
                    left: event.clickEvent.x - 100 + "px",
                    height: "40px",
                  },
                };
              } else {
                this.parseResult(data);
              }
              resolve(event);
            });
          }
        } else {
          // 非全頁 => 導新頁
          if (!this.expandAll) {
            this.getBelowMember(event.item.parent_name, 1).then((data) => {
              this.item = data;
            });
          }
        }
      });

      this.searchData.targetName = "";
    },
    parseResult(data, reset = false) {
      // 全頁模式
      if (this.expandAll) {
        event.item.children = data.children;
      } else {
        // 已刪除的TG會員 不切換內容，僅作提示
        if (!("is_tgbusiness" in data)) {
          data.is_tgbusiness = 0;
        }
        if (data.is_tgbusiness == 0 && data.is_del == 1) {
          this.$message({
            message: this.$t("page.tg_business.my-team.notFound"),
            offset: 150,
            type: "warning",
          });
        } else {
          if (reset) {
            this.item = data;
          } else {
            // 同一個上層，載入分頁
            if (this.item.username == data.username) {
              let item = JSON.parse(JSON.stringify(this.item));
              item.children = [...item.children, ...data.children];
              this.item = item;
            } else {
              this.item = data;
            }
          }
        }
      }
    },
    handleToTopLevel() {
      this.getBelowMember(this.loginUser, 1).then((data) => {
        this.item = data;
        this.searchData.targetName = "";
      });
    },
    handleSearch() {
      if (!this.expandAll) {
        this.getBelowMember(this.searchData.targetName, 1).then((data) => {
          if (!data.username) {
            this.$message({
              message: this.$t("page.tg_business.my-team.notFound"),
              offset: 150,
              type: "warning",
            });
          } else {
            this.parseResult(data, true);
          }
        });
      }
    },
    handleShowItemInfo(event) {
      event.fetch = new Promise((resolve) => {
        api
          .getMemberInfo({ targetName: event.item.username })
          .then((response) => {
            if(response.retcode == 0){
              resolve(response.data);
            }
          })
          .catch(() => {});
      });
    },
    handleScroll() {
      if (!this.hasNextPage || this.loading) {
        return;
      }

      this.getBelowMember(this.item.username, this.pagination.page + 1).then(data => {
        this.parseResult(data);
      });
    }
  },
};
</script>
